import React, { forwardRef, useState } from 'react'
import PropTypes from 'prop-types'

import Input from '../components/Input'
import Label from '../components/Label'
import S from '../components/Input.styled'
import { Cross } from '../../Svg'

const TextInput = forwardRef(
  (
    {
      value,
      type = 'text',
      name = '',
      className = '',
      labelClassName = '',
      inputClassName = '',
      label,
      onChange,
      onFocus = () => {},
      onBlur = () => {},
      onKeyDown = () => {},
      isDisabled = false,
      isReadOnly = false,
      wrapperRef,
      isError = false,
      errorMsg,
      isClearable = false,
      onClearClick = () => {},
      accentColor,
    },
    ref
  ) => {
    const [isResetFocused, setIsResetFocused] = useState(false)
    const inputLabelId = `input-label-${Math.random().toString(36).slice(2, 11)}`

    const onTypeSearch = type === 'search' && value ? true : false

    const handleResetOnEnter = (e) => {
      if (e.key === 'Enter') {
        onClearClick()
        ref && ref.current && ref.current.focus()
      }
    }

    return (
      <Label
        id={inputLabelId}
        className={`base-input ${className}`}
        labelClassName={`base-label ${labelClassName}`}
        label={errorMsg || label}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        ref={wrapperRef}
        isError={isError}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        isResetFocused={isResetFocused}
        accentColor={accentColor}
      >
        {({ onChange, onFocus, onBlur, onKeyDown }) => (
          <>
            <Input
              ref={ref}
              name={name}
              value={value}
              type={type}
              className={inputClassName}
              onChange={onChange}
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={onKeyDown}
              isDisabled={isDisabled}
              isReadOnly={isReadOnly}
              aria-describedby={inputLabelId}
            />
            {(onTypeSearch || isClearable) && (
              <S.ResetIcon
                tabIndex="0"
                onClick={onClearClick}
                onKeyDown={(e) => handleResetOnEnter(e)}
                isResetFocused={isResetFocused}
                onFocus={() => setIsResetFocused(true)}
                onBlur={() => setIsResetFocused(false)}
                onMouseDown={(e) => e.preventDefault()}
              >
                <Cross className="reset-icon" />
              </S.ResetIcon>
            )}
          </>
        )}
      </Label>
    )
  }
)

TextInput.propTypes = {
  value: PropTypes.string.isRequired,
  type: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  wrapperRef: PropTypes.node,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string,
  isClearable: PropTypes.bool,
  onClearClick: PropTypes.func,
  accentColor: PropTypes.string,
}

export default TextInput
